import React from 'react';
import { LineSkeleton } from 'components/base/Skeletons';
import styled from 'styled-components';

const StyledLoadinMetricsState = styled.div`
  display: flex;
  padding-left: 2rem;
  margin-top: 5rem;
  height: 30rem;
  flex-direction: column;
`;

const StyledLineSkeleton = styled.div`
  margin-top: 3rem;
`;

const LoadingMetricsState = () => {
  const sizes = [35, 45, 52, 33, 35, 43, 47];
  return (
    <StyledLoadinMetricsState>
      {sizes.map((size, index) => (
        <StyledLineSkeleton key={index}>
          <LineSkeleton size={size} />
        </StyledLineSkeleton>
      ))}
    </StyledLoadinMetricsState>
  );
};

export default LoadingMetricsState;
